import { useFormContext } from "react-hook-form";
import InputText from "../../components/InputText";
import PriceInput from "../../components/PriceInput";
import { CONTRACT_RECORD_TYPE } from "../../constant";
import DatePicker from "../../components/DatePicker";
import SelectField from "../../components/SelectField";
import { RootState } from "../../store/root-reducer";
import { connect, useDispatch } from "react-redux";
import { useEffect } from "react";
import Loader from "../../components/Loader";
import { isScopeLoading } from "../../store/scope-loading/helpers";
import moment from "moment";
import { getSkuOptions } from "../../store/unregister-contract/actions";
import { UnRegisterScope } from "../../store/unregister-contract/types";
import { useSearchParams } from "react-router";

function PurchaseInformation({ sku, loading }) {
  const { control, setValue, getValues } = useFormContext();
  const dispatch = useDispatch();
  const delivery_date = getValues("delivery_date");
  const [searchParams] = useSearchParams();
  const dealerId = searchParams.get("dealerId");
  useEffect(() => {
    if (!delivery_date && sku.length === 0) {
      dispatch(
        getSkuOptions({
          deliveryDate: moment().format("MM-DD-YYYY"),
          dealerId: dealerId,
        })
      );
    }
    if (sku.length === 0) {
      setValue("protectall_sku", null);
    }
  }, [delivery_date, dispatch, setValue, sku.length, dealerId]);

  return (
    <div className="max-w-[700px] w-full mx-auto grid gap-y-10">
      <Loader isLoading={loading} />
      <div className="grid gap-y-3">
        <InputText
          name="invoice_number"
          control={control}
          type="text"
          label="Invoice Number"
          required
        />
        <SelectField
          control={control}
          name="protectall_sku"
          label="Protection Plan SKU"
          required
          isSearchable
          isClearable
          placeholder="Plan Type (SKU)"
          options={sku.map((item) => ({
            label: `${item.planType} (${item.sku})`,
            value: item.planType,
          }))}
        />
        {/* <InputText
          control={control}
          name="protectall_sku"
          type="text"
          label="Nikon Care SKU"
          required
        /> */}
        {/* <InputText
          control={control}
          name="dealer_sku"
          type="text"
          label="Dealer SKU"
        /> 
        <InputText
          control={control}
          name="dealer_contract_number"
          type="text"
          label="Dealer Contract Number"
        /> */}
        <InputText
          name="reference_number"
          control={control}
          type="text"
          label="Reference Number"
        />
        <SelectField
          name="record_type"
          control={control}
          defaultValue={CONTRACT_RECORD_TYPE[0]}
          label="Record Type"
          options={CONTRACT_RECORD_TYPE}
          required
        />
        <DatePicker
          control={control}
          name="contract_purchase_date"
          label="Contract Purchase Date"
          defaultValue={new Date()}
          required
        />
        <DatePicker
          control={control}
          name="delivery_date"
          label="Contract Delivery Date"
          defaultValue={new Date()}
          onChange={(selectedDate) => {
            dispatch(
              getSkuOptions({
                deliveryDate: moment(selectedDate).format("MM-DD-YYYY"),
                dealerId: dealerId,
              })
            );
          }}
        />
        <PriceInput
          control={control}
          name="contract_retail_price"
          label="Contract Retail Price"
          required
        />
        <PriceInput
          control={control}
          name="total_product_retail_value"
          label="Total Product Retail Value"
          required
        />
      </div>
    </div>
  );
}

const mapStateProps = (state: RootState) => {
  return {
    sku: state.unRegister.sku || [],
    loading: isScopeLoading(state.scopeLoading, `${UnRegisterScope}-skus`),
  };
};

export default connect(mapStateProps)(PurchaseInformation);
